module.exports = __webpack_public_path__ + "static/media/hot62.02e29e78.jpg";